import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LavorisService from "../../services/LavorisService";
import { RootState } from "../../store/combineReducer";

const TwoFA = () => {
  const userId = useSelector((state: RootState) => state.user.userId);
  const LavorisInstance = LavorisService.getInstance();
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const getUser = async () => {
    try {
      setLoading(true);
      const userDb = await LavorisInstance.User.findUserById(userId);
      setUser(userDb);
    } catch (error) {
      console.error("Error al obtener el usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  const setTwoFactorEnabled = async () => {
    try {
      setLoading(true);
      await LavorisInstance.User.updateUserById(
        { twoFactorEnabled: !user?.twoFactorEnabled },
        userId
      );
      await getUser();
    } catch (error) {
      console.error("Error al actualizar 2FA:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) getUser();
  }, [userId]);

  return (
    <div className="twofa-container atendoo-card mb-3">
      <div className="twofa-content">
        <div className="twofa-info">
          <h3 className="twofa-title">
            Autenticación en dos pasos
          </h3>
          <p className={"twofa-status" + (user?.twoFactorEnabled ? " active" : "")}>
            {user?.twoFactorEnabled ? "Activada" : "Desactivada"}
          </p>
        </div>

        <button
          onClick={setTwoFactorEnabled}
          disabled={loading}
          className={`twofa-switch ${user?.twoFactorEnabled ? 'active' : ''} ${loading ? 'loading' : ''}`}
        >
          <span className="twofa-switch-handle">
            {loading && <div className="twofa-spinner"></div>}
          </span>
        </button>
      </div>
    </div>
  );
};

export default TwoFA;